export default __webpack_public_path__ + "static/media/ic-research.84d6fe8f.svg";